<template>
    <div>
        <div>
            <b-button class="me-2" variant="light" @click="$eventHub.$emit('navigateBack')">
                <i class="fas fa-arrow-left"></i> Back
            </b-button>
            
            <b-button variant="primary" v-if="edit == false" @click="edit = true">
                <i class="fas fa-pen"></i> Edit
            </b-button>
            <b-button variant="success" v-else @click="edit = false">
                <i class="fas fa-save"></i> Save
            </b-button>
        </div>
        <hr>
        <b-form>
            <b-row>
                <b-col cols="8">
                    <!--
                    <b-form-group class="mb-3">
                        <b-row>
                            <b-col cols="12">
                                <h5>Contact Details</h5>
                            </b-col>
                            <b-col cols="6" class="mb-3">
                                <label for="">Name</label>
                                <b-form-input :readonly="!edit"></b-form-input>
                            </b-col>
                            <b-col cols="6">
                                <label for="">Email</label>
                                <b-form-input :readonly="!edit"></b-form-input>
                            </b-col>

                            <b-col cols="6" class="mb-3">
                                <label for="">ID Number</label>
                                <b-form-input :readonly="!edit"></b-form-input>
                            </b-col>
                            <b-col cols="6">
                                <label for="">Position</label>
                                <b-form-input :readonly="!edit"></b-form-input>
                            </b-col>

                            <b-col cols="6" class="mb-3">
                                <label for="">Contact Number</label>
                                <b-form-input :readonly="!edit"></b-form-input>
                            </b-col>
                        </b-row>
                    </b-form-group>
                    -->

                    <b-form-group>
                        <b-row>
                            <b-col cols="12">
                                <h5>Company Details</h5>
                            </b-col>
                            <b-col cols="6" class="mb-3">
                                <label for="">Company Name</label>
                                <b-form-input v-model="overview_data.company_name" :readonly="!edit"></b-form-input>
                            </b-col>
                            <b-col cols="6">
                                <label for="">Email</label>
                                <b-form-input v-model="overview_data.company_email" :readonly="!edit"></b-form-input>
                            </b-col>

                            <b-col cols="6" class="mb-3">
                                <label for="">Registration Number</label>
                                <b-form-input :readonly="!edit"></b-form-input>
                            </b-col>
                            <b-col cols="6">
                                <label for="">GPS Coordinates</label>
                                <b-form-input v-model="overview_data.company_gps_coords" :readonly="!edit"></b-form-input>
                            </b-col>

                            <b-col cols="6" class="mb-3">
                                <label for="">Contact Number</label>
                                <b-form-input v-model="overview_data.company_phone" :readonly="!edit"></b-form-input>
                            </b-col>
                            <b-col cols="12" class="mb-3">
                                <label for="">Physical Address</label>
                                <b-form-textarea v-model="overview_data.company_address" :readonly="!edit" no-resize max-rows="5" rows="2"></b-form-textarea>
                            </b-col>

                            <b-col cols="6">
                                <label for="">Suburb</label>
                                <b-form-input :readonly="!edit"></b-form-input>
                            </b-col>
                            <b-col cols="6">
                                <label for="">Code</label>
                                <b-form-input :readonly="!edit"></b-form-input>
                            </b-col>
                        </b-row>
                    </b-form-group>
                </b-col>
            </b-row>
        </b-form>
    </div>
</template>

<script>
import { ccbAdminState } from '@/state/helpers'
export default {
    data:() => ({
        edit: false,
    }),
    computed:{
        ...ccbAdminState,
        overview_data(){
            return this.client_data.client;
        },
    },
    methods:{},
    mounted(){},
}
</script>

<style>

</style>